import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const youtube: MusicService = {
  id: 'youtube',
  name: 'YouTube',
  shortName: 'YouTube',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: false,
  color: {
    primary: '#FF0000',
    label: '#FF0000',
    background: '#8a6664',
  },
  importerID: ImporterID.Youtube,
  musicAPIID: MusicAPIIntegrationID.Youtube,
  linkType: 'youtube',
  assets: {
    logo: { light: 'youtube-light.svg', dark: 'youtube-dark.svg' },
    logoPadding: { light: 'youtube-light-padding.svg', dark: 'youtube-dark-padding.svg' },
    logoColor: { light: 'youtube-color-light.svg', dark: 'youtube-color-dark.svg' },
    logoColorPadding: {
      light: 'youtube-color-light-padding.svg',
      dark: 'youtube-color-dark-padding.svg',
    },
    logoOnBackground: 'youtube-dark.svg',
  },
  whatIsDescription: musicServiceMessages.youtubeWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: false,
    doesSupportRemovingTracksFromLibrary: false,
    doesSupportFetchingLibraryAlbums: false,
    doesSupportFetchingAlbums: false,
    doesSupportFetchingAlbumTracks: false,
    doesSupportAddingAlbums: false,
    doesSupportRemovingAlbums: false,
    doesSupportFetchingLibraryArtists: false,
    doesSupportFetchingArtists: false,
    doesSupportAddingArtistsToLibrary: false,
    doesSupportRemovingArtistsFromLibrary: false,
    doesSupportSearchByISRC: false,
    doesReturnISRC: false,
    doesReturnPreviewURL: false,
    doesReturnUserEmail: true,
    doesReturnUserCountry: false,
    maxLimit: 50,
  },
};
